import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export interface FormValues {
  name?: string
  export_type?: string
  file_format?: string
  time_format?: string
  project_ids?: number[]
  employee_ids?: number[]
  employee_selection?: EmployeeSelectorV2MultiSelectState
  date_range?: string
  from_date?: string
  to_date?: string
  include_employees_without_time_tracked?: boolean
  all_projects?: boolean
}

const defaultEmployeeSelection: EmployeeSelectorV2MultiSelectState = {
  type: 'manual',
  ids: [],
}

export const EXPORT_PROJECTS_FORM_SCHEMA = {
  name: 'string',
  export_type: 'string',
  file_format: 'string',
  time_format: 'string',
  project_ids: 'string',
  employee_ids: 'string',
  employee_selection: 'any',
  date_range: 'string',
  from_date: 'date',
  to_date: 'date',
  include_employees_without_time_tracked: 'boolean',
  all_projects: 'boolean',
} as const

export const getDefaultExportFormAttributes = (overrides?: Partial<FormValues>): FormValues => ({
  name: '',
  export_type: 'total_time',
  file_format: 'csv',
  time_format: '',
  project_ids: [],
  employee_ids: [],
  employee_selection: defaultEmployeeSelection,
  date_range: 'last_90_days',
  from_date: '',
  to_date: '',
  include_employees_without_time_tracked: false,
  all_projects: false,
  ...overrides,
})
